<template>
	<v-card>
		<v-container>
			<div class="text-h1 d-flex align-center">
				<v-icon size="22" color="#F7CE03" class="mr-2">mdi-alert</v-icon>
				Warning
			</div>
			<v-container>
				<p class="text-body-2">
					You are about to change the playlist going to your listeners. Are you sure you want to change to the
					<strong>{{ PriorityLanes.getNameByPriority(this.priorityLane) }}</strong> playlist?
				</p>
				<v-checkbox v-if="this.priorityLane !== PriorityLanes.Scheduled.priority && sequencerModeIsAuto"
					v-model="sequencerModeIsAuto" readonly density="compact" class="pt-2"
					label="Station will be stopped for sync to work" hide-details/>
			</v-container>
			<div class="d-flex justify-end">
				<v-btn variant="text" color="primary" :disabled="disabledButton" @click.stop="$emit('close')">
					Cancel
				</v-btn>
				<v-btn variant="elevated" color="primary" :disabled="disabledButton" @click="changePriorityLane">
					Change Playlist
				</v-btn>
			</div>
		</v-container>
	</v-card>
</template>

<script>
import PriorityLanes from "@/enums/PriorityLanes";
import SequencerModes from "@/enums/SequencerModes";

export default {
	name: "WarningDialog",

	data() {
		return {
			disabledButton: false
		}
	},

	computed: {
		PriorityLanes() {
			return PriorityLanes;
		},

		sequencerModeIsAuto() {
			return this.$store.getters.getSequencerMode(this.selectedStationID) === SequencerModes.Auto;
		}
	},

	props: ["priorityLane", "selectedStationID"],

	emits: ["changePriorityLane", "close"],

	methods: {
		changePriorityLane() {
			this.disabledButton = true;
			this.$emit("changePriorityLane", this.sequencerModeIsAuto);
		}
	}
}
</script>